module.exports = __webpack_public_path__ + "static/media/animated-logo.5c3f58ea.gif";